export default __webpack_public_path__ + "static/media/Plantilla_de_productos_controlB.3e81d031.xlsx";